export function isPortfolioGenerationPreviewRoute(route) {
    return Boolean(route?.params?.generationId)
        && (route?.meta?.portfolioGenerationPreview === true
            || route?.path?.startsWith("/portfolio-generation/") === true);
}

export function getPortfolioGenerationPreviewPath(route, projectShortId = null) {
    const generationId = route?.params?.generationId;
    if (!isPortfolioGenerationPreviewRoute(route) || !generationId) {
        return null;
    }

    const generationPath = `/portfolio-generation/${encodeURIComponent(generationId)}/preview`;
    return projectShortId
        ? `${generationPath}/${encodeURIComponent(projectShortId)}`
        : generationPath;
}

export function findPortfolioGenerationPreviewPage(payload, projectShortId) {
    if (!payload || !projectShortId) {
        return null;
    }

    const pages = [
        ...(Array.isArray(payload.portfolioPages) ? payload.portfolioPages : []),
        ...(Array.isArray(payload.caseStudies) ? payload.caseStudies : [])
    ];

    return pages.find((page) => page?.shortId === projectShortId) || null;
}
